import { useState } from 'react';

export default function AddressController() {
  const [address, setAddress] = useState({
    formatted_address: '',
    msa: '',
    county: '',
    lat: '',
    lng: ''
  });

  const updateFormattedAddress = (value) => {
    setAddress({
      ...address,
      formatted_address: value
    });
  };

  const updateAddress = (place) => {
    setAddress({...place})
  };

  return { address, updateAddress, updateFormattedAddress };
}
